import { gql } from '@apollo/client';

export const GET_PROFILE = gql`
  query getMyProfile {
    profileNewModel {
      id
      managedBy
      userId
      email
      firstName
      lastName
      scopes
      revertBlocked
      hierarchy {
        id
        type
      }
      linkedAccounts {
        userId
        email
        hierarchy {
          id
          type
          name
        }
        scopes
      }
      children {
        institutionType
        institutionId
        institutionName
        hierarchyType
        hierarchyId
        hierarchyName
        gradeLevel
        schoolYear
        schoolType
        childUid
        status
        community
        postalCode
        institutionGradeLevel
      }
      academicGroupMemberships {
        groupName
        groupId
        hierarchyName
        hierarchyId
      }
    }
  }
`;

export const GET_PROFILE_CHILDREN = gql`
  query getMyProfile {
    profileNewModel {
      children {
        institutionId
        gradeLevel
        schoolYear
        status
        childUid
      }
    }
  }
`;
